module.exports = __webpack_public_path__ + "img/avatar.e047379c.jpg";